import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./PracticePerfectVideos.css";
import Header from "../../Header/Header";
import Spinner from "../../Spinner/Spinner";
import Tooltip from "react-bootstrap/Tooltip";
import { Modal, OverlayTrigger } from "react-bootstrap";
import { handleException } from "../../../app/util/util";
import { get, post, put } from "../../../app/shared/http";
import useSearchVideo from "./PracticePerfectVideosSearch";
import loaderColors1 from "../../Spinner/loaderColors1.gif";
import { setUserDetails } from "../../../app/redux/UserSlice";
import { PPRetakeQuizDialog } from "./PPQuizTaker/PPQuizRetakeDialog";
import {
  withAuth,
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
export function PracticePerfectVideos() {
  const history = useHistory();
  const { isbn } = useParams();
  const dispatch = useDispatch();
  const isMounted = useRef(false);
  const tollTipTargets = useRef(null);
  const isLandingPageInfor = useRef(false);
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const ppIsbn =
    isbn && isbn !== "undefined" ? isbn : localStorage.getItem("bookIsbn");
  const authToken = userVO.apJwtAuthenticationToken
    ? userVO.apJwtAuthenticationToken
    : localStorage.getItem("apJwtAuthenticationToken");
  const [ppTopics, setPPTopics] = useState([]);
  const [classCode, setClassCode] = useState("");
  const [classInfo, setClassInfo] = useState("");
  const [searchVideo, setSearchVideo] = useState("");
  const [isBubbleMsg, setBubbleMsg] = useState(false);
  const [isDropClass, setDropClass] = useState(false);
  const [isJoinClass, setIsJoinClass] = useState(false);
  const [isCodeRedeem, setCodeRedeem] = useState(false);
  const [videoPageInfo, setVideoPageInfo] = useState("");
  const [errClassCode, setErrClassCode] = useState(false);
  const [featuredVideo, setFeaturedVideo] = useState(null);
  const [isPPVideoPageLoad, setIsPPVideoPageLoad] = useState(true);
  const [displayView, setDisplayView] = useState("thumbnail_view");
  const [isInvalidClassCode, setInvalidClassCode] = useState(false);
  const [isEnableDropButton, setEnableDropButton] = useState(false);
  const [isAlreadyRedeemCode, setAlreadyRedeemCode] = useState(false);
  const [videosRecentlyWatched, setVideosRecentlyWatched] = useState();
  const [isResetNotificationData, setResetNotificationData] = useState();
  const [isShowStdQuizResetPopup, setShowStdQuizResetPopup] = useState(false);
  const {
    videosFound,
    searchVideos,
    handleResetVideoState,
    isSearching,
    showMessage,
    showVideosFound,
  } = useSearchVideo(searchVideo);
  const ppQuizResetPopupFocus = useRef(null);
  useEffect(() => {
    dispatch(setUserDetails(userVO));
    userConfigurationsByIdAndKey();
  }, []);
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  const selectViewDet = (layout) => {
    if (layout != displayView) {
      setDisplayView(layout);
    }
  };
  const handleChangeSearchVideo = (e) => setSearchVideo(e.currentTarget.value);
  const handleSearchVideo = (e) => {
    if (e.charCode === 13 && e.code === "Enter") {
      searchVideos(videoPageInfo.ProductID, videoPageInfo.SATagId);
    }
  };
  const handleClickSearchVideo = () => {
    searchVideos(videoPageInfo.ProductID, videoPageInfo.SATagId);
  };
  const handleBackVideoLib = () => {
    handleResetVideoState();
    setSearchVideo("");
  };
  const getPPvideoPagedetails = async () => {
    let reqData = { productISBN: ppIsbn };
    post("/PP/get-PPproductDetails", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else {
          if (data.ValidityStatus === "Expired") {
            localStorage.setItem("PPException", data.ValidityStatus);
            window.location.replace(window.location.origin + "/invalidUrl");
            return false;
          }
          localStorage.removeItem("PPException");
          setVideoPageInfo(data);
          localStorage.setItem("ppLandingInfo", JSON.stringify(data));
          localStorage.setItem("ppProductName", data.ProductName);
          localStorage.setItem("ppProductTagId", data.SATagId);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getRecentlyWatchedVideo = async () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          themisProductId: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          themisSubjectAreaId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: videoPageInfo.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: videoPageInfo.SATagId,
      ppProductVO: { productId: videoPageInfo.ProductID },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/managePP/getRecentlyWatchedVideo`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "true" && data.ppSubTopicVOList) {
          var ppSubTopicVO = Array.isArray(data.ppSubTopicVOList)
            ? data.ppSubTopicVOList
            : [data.ppSubTopicVOList];
          setVideosRecentlyWatched(ppSubTopicVO);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getFeaturedVideo = async () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          themisSubjectAreaId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: videoPageInfo.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: videoPageInfo.SATagId,
      ppProductVO: { productId: videoPageInfo.ProductID },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/managePP/getFeaturedVideo`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "true" && data.ppSubTopicVO) {
          setFeaturedVideo(data.ppSubTopicVO);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getPPTopicsBySATagId = async () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          themisSubjectAreaId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: videoPageInfo.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: videoPageInfo.SATagId,
      ppProductVO: { productId: videoPageInfo.ProductID },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const data = await (
      await fetch(
        `${localStorage.getItem("ENV")}/managePP/getPPTopicsBySATagId`,
        requestOptions,
      )
    ).json();
    if (data.status == "true") {
      if (data.ppTopicVOList && data.ppTopicVOList.length) {
        data.ppTopicVOList = Array.isArray(data.ppTopicVOList)
          ? data.ppTopicVOList
          : [data.ppTopicVOList];
        data.ppTopicVOList.map((video) => {
          if (video.ppSubTopicVOList) {
            video.ppSubTopicVOList = Array.isArray(video.ppSubTopicVOList)
              ? video.ppSubTopicVOList
              : [video.ppSubTopicVOList];
          }
        });
        setDisplayView(data.ppProductVO.videoLayout);
        setPPTopics(data.ppTopicVOList);
      }
      setIsPPVideoPageLoad(false);
    } else if (data.wkErrorCode) {
      handleException(data);
    }
  };
  const updateVideoLayoutSettings = () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          themisSubjectAreaId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: videoPageInfo.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: videoPageInfo.SATagId,
      ppProductVO: {
        videoLayout: displayView,
        productId: videoPageInfo.ProductID,
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/managePP/updateVideoLayoutSettings`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          console.info("PP videos settings are updated");
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const onHandleTakeQuiz = (subTopictagId) => {
    localStorage.removeItem("ppQuizInstances");
    history.push(
      `/pp-quiz/graded/${ppIsbn}/${subTopictagId}/${videoPageInfo.SATagId}/video`,
    );
  };
  const onHandleContinueQuiz = (video) => {
    localStorage.setItem("ppQuizInstances", JSON.stringify(video));
    history.push(
      `/pp-quiz/graded/${ppIsbn}/${video.subTopictagId}/${videoPageInfo.SATagId}/video`,
    );
  };
  const onHandleRetakeQuiz = async (subTopictagId) => {
    localStorage.removeItem("ppQuizInstances");
    history.push(
      `/pp-quiz/graded/${ppIsbn}/${subTopictagId}/${videoPageInfo.SATagId}/video`,
    );
  };
  const onHandleQuizReview = (video) => {
    history.push(
      `/pp-quiz/results/${ppIsbn}/${video.subTopictagId}/${videoPageInfo.SATagId}/${video.instanceId}`,
    );
  };
  function ContinueQuizButton({ video }) {
    return (
      <p className="ppvQuizUrlTxt">
        {" "}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onHandleContinueQuiz(video);
          }}
        >
          Continue Quiz
        </a>{" "}
      </p>
    );
  }
  const videoButton = (video) => {
    if (video.totalQuestions) {
      if (video.gradedQuizIdentifier && video.instanceId) {
        if (
          video.incompleteQuizInstanceId === undefined &&
          video.incompleteQuizInstanceURL === undefined
        ) {
          return (
            <>
              <div className="mb-3">
                <PPRetakeQuizDialog
                  onHandleReviewQuiz={() => onHandleQuizReview(video)}
                  details={false}
                  video={video}
                  onHandleRetakeQuizz={() =>
                    onHandleRetakeQuiz(video.subTopictagId)
                  }
                />
              </div>
            </>
          );
        }
        if (
          parseInt(video.instanceId) > parseInt(video.incompleteQuizInstanceId)
        ) {
          return (
            <>
              <div className="mb-3">
                <PPRetakeQuizDialog
                  onHandleReviewQuiz={() => onHandleQuizReview(video)}
                  details={false}
                  video={video}
                  onHandleRetakeQuizz={() =>
                    onHandleRetakeQuiz(video.subTopictagId)
                  }
                />
              </div>
            </>
          );
        } else if (
          parseInt(video.instanceId) < parseInt(video.incompleteQuizInstanceId)
        ) {
          return <ContinueQuizButton video={video} />;
        }
      } else if (
        video.incompleteQuizInstanceURL &&
        video.incompleteQuizInstanceId
      ) {
        if (
          parseInt(video.incompleteQuizInstanceId) > parseInt(video.instanceId)
        ) {
          return <ContinueQuizButton video={video} />;
        }
        return <ContinueQuizButton video={video} />;
      }
      return (
        <p className="ppvQuizUrlTxt">
          {" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onHandleTakeQuiz(video.subTopictagId);
            }}
          >
            Take Quiz
          </a>{" "}
        </p>
      );
    } else {
      return <> </>;
    }
  };
  const goToWatchVideo = (video) => {
    if (video.subTopictagId) {
      history.push(`/pp-video-library/${ppIsbn}/video/${video.subTopictagId}`);
    }
  };
  useEffect(() => {
    getPPvideoPagedetails();
    getPPRestNotification();
  }, []);
  // Update video settings when display view change. prevent updating on first time render.
  useEffect(() => {
    if (isMounted.current) {
      updateVideoLayoutSettings();
    } else {
      isMounted.current = true;
    }
  }, [displayView]);
  useEffect(() => {
    if (isLandingPageInfor.current) {
      getRecentlyWatchedVideo();
      getFeaturedVideo();
      getPPTopicsBySATagId();
    } else {
      isLandingPageInfor.current = true;
    }
  }, [videoPageInfo]);
  const joinClass = async () => {
    setErrClassCode(false);
    setInvalidClassCode(false);
    if (classCode === "") {
      setErrClassCode(true);
    } else {
      setErrClassCode(false);
      setIsPPVideoPageLoad(true);
      let reqtData = {
        ppClassVO: {
          ppClassCode: classCode,
          ppguidId: localStorage.getItem("ppProductTagId"),
        },
      };
      post("/PP/redeemClassCode", reqtData, "qpAPI")
        .then(handleResponse)
        .then((response) => response.json())
        .then(handleJwtTokenForKeppMeLoggedIn)
        .then((data) => {
          if (data.Exception) {
            setIsPPVideoPageLoad(false);
            const exceptStr = data.Exception;
            if (exceptStr === "Invalid PP Class Code")
              setInvalidClassCode(true);
            else if (exceptStr === "Already Redeem Another PP Class Code")
              setAlreadyRedeemCode(true);
            return false;
          }
          if (data) {
            setClassCode("");
            setCodeRedeem(true);
            setClassInfo(data[0]);
            setIsJoinClass(false);
            setEnableDropButton(true);
            setIsPPVideoPageLoad(false);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const dropClass = async () => {
    setIsPPVideoPageLoad(true);
    let reqtData = {
      ppClassVO: {
        ppguidId: localStorage.getItem("ppProductTagId"),
        ppClassId: classInfo.ppClassId || videoPageInfo.ppClassVO.ppClassId,
        ppClassName:
          classInfo.ppClassName || videoPageInfo.ppClassVO.ppClassName,
      },
    };
    post("/PP/dropClassForStudent", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Success) {
          setIsPPVideoPageLoad(false);
          setEnableDropButton(false);
          setClassInfo("");
          setDropClass(false);
          setVideoPageInfo({ ...videoPageInfo, ppClassVO: "" });
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const compressClassName = (classInfo) => {
    const classNameText = `${classInfo.ppClassName} ${classInfo.ppSemester} ${classInfo.ppYear}`;
    if (classNameText.length <= 42) {
      return classNameText;
    } else {
      return classNameText.substring(0, 42) + "...";
    }
  };
  const handleJoinKeyPress = (e) => {
    if (e.key === "Enter") {
      joinClass();
    }
  };
  const handleJoinClass = () => {
    setClassCode("");
    setIsJoinClass(true);
    setErrClassCode(false);
    setInvalidClassCode(false);
    setAlreadyRedeemCode(false);
  };
  function userConfigurationsByIdAndKey() {
    const ppStdId = userVO.userId;
    get(
      `/PP/Professor/userConfigurationsByIdAndKey?key=PROF_WELCOME_MSG&userId=${ppStdId}`,
      "qpAPI",
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setBubbleMsg(data.showPopUp);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  const updateUserConfiguration = async () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      userConfiguration: {
        value: "3",
        userId: userVO.userId,
        key: "PROF_WELCOME_MSG",
        additionalDetails: null,
      },
    };
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/PP/Professor/updateUserConfiguration`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.blob())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        console.info("updateUserConfiguration");
        setBubbleMsg(false);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const tooltip = (classInfo || videoPageInfo.ppClassVO) && (
    <Tooltip className="ppStdClassDetailToolTip font-weight-bold">
      {`You're enrolled in Professor ${classInfo.profLastName || videoPageInfo.ppClassVO.profLastName}'s "${classInfo.ppClassName || videoPageInfo.ppClassVO.ppClassName} ${classInfo.ppSemester || videoPageInfo.ppClassVO.ppSemester} ${classInfo.ppYear || videoPageInfo.ppClassVO.ppYear}" class.`}
    </Tooltip>
  );
  useEffect(() => {
    if (isResetNotificationData != undefined) {
      updatePPRestNotification();
    }
  }, [isResetNotificationData]);
  const getPPRestNotification = () => {
    get("/admin/RestNotification?key=pp&user_Id=" + userVO.userId, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else {
          if (data.status == true) {
            setShowStdQuizResetPopup(true);
            setResetNotificationData(data.NotificationList);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updatePPRestNotification = (notifyValue) => {
    let collectionOfRNjson = [];
    isResetNotificationData &&
      isResetNotificationData.forEach((notificationVal) => {
        let RNjson = {
          key_name: notificationVal.key_name,
          notificationId: notificationVal.NotificationId,
          userId: userVO.userId,
          value: notifyValue === 3 ? 3 : parseInt(notificationVal.value) + 1,
        };
        collectionOfRNjson.push(RNjson);
      });
    let reqData = {
      notificationList: collectionOfRNjson,
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: userVO.keepMeLoggedInFlag,
      },
    };
    put("/admin/updateRestNotification", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  useEffect(() => {
    if (ppQuizResetPopupFocus.current !== null) {
      ppQuizResetPopupFocus.current.focus();
    }
  }, [isShowStdQuizResetPopup]);
  return (
    <>
      <Spinner
        loading={isPPVideoPageLoad}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <Spinner
        loading={isSearching}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <Header
        userVO={userVO}
        pageName="PPVideos"
        isbn={ppIsbn}
        ppvideoid={videoPageInfo.ProductID}
      ></Header>
      <div className="container">
        <div className="card ppvContainerSection">
          <div className="card-body ppvContainerCard">
            {isPPVideoPageLoad === false ? (
              <>
                <div className="row">
                  <div
                    className={
                      userVO.userRole === "Professor"
                        ? "col-xl-6 col-lg-6 col-md-7 col-sm-12 col-xs-12"
                        : "col-xl-6 col-lg-5 col-md-6 col-sm-12 col-xs-12 pr-0"
                    }
                  >
                    <div className="ppvLogoContainer">
                      <p>
                        <span className="ppvCommonStyle ppvLogoBoldText">
                          PracticePerfect<sup>TM</sup>
                        </span>
                        <span className="ppvCommonStyle ppvLogoText">
                          {" "}
                          {videoPageInfo.ProductName}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      userVO.userRole === "Professor"
                        ? "col-xl-6 col-lg-6 col-md-5 col-sm-12 col-xs-12"
                        : "col-xl-6 col-lg-7 col-md-6 col-sm-12 col-xs-12"
                    }
                  >
                    <div className="ppvSearchBox">
                      {userVO.userRole === "Professor" ? (
                        <div className="input-group">
                          <label htmlFor="studentSearchVideoInput" className="sr-only">
                            Search videos
                          </label>
                          <input
                            type="text"
                            disabled={isSearching}
                            value={searchVideo}
                            onChange={handleChangeSearchVideo}
                            onKeyPress={handleSearchVideo}
                            className="form-control ppvSearchInput"
                            aria-label="Search videos"
                            id="studentSearchVideoInput"
                          />
                          <button
                            className="btn ppvSearchButton"
                            disabled={isSearching}
                            value={searchVideo}
                            onClick={handleClickSearchVideo}
                            type="button"
                          >
                            Search
                          </button>
                        </div>
                      ) : (
                        <div className="row">
                          <div
                            className="col-xl-9 col-lg-9 col-md-7 col-sm-7 col-8 pr-0 text-rights"
                            style={{ marginTop: "1%" }}
                          >
                            {(classInfo || videoPageInfo.ppClassVO) && (
                              <h6
                                className="font-weight-bold ellipsis classTabFontFamily"
                                style={{ textAlign: "right" }}
                              >
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={tooltip}
                                >
                                  <i
                                    data-testid="class_info"
                                    className="fa fa-info-circle text-primary mr-1 classTabIconsColor"
                                    aria-hidden="true"
                                  ></i>
                                </OverlayTrigger>
                                {compressClassName(
                                  classInfo
                                    ? classInfo
                                    : videoPageInfo.ppClassVO,
                                )}
                              </h6>
                            )}
                          </div>
                          <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-4 text-right">
                            {isEnableDropButton || videoPageInfo.ppClassVO ? (
                              <button
                                className="btn ppClassDrop-btn"
                                style={{ width: "90px" }}
                                onClick={() => setDropClass(true)}
                              >
                                Drop Class
                              </button>
                            ) : (
                              <button
                                className="btn ppClassDrop-btn w-100"
                                ref={tollTipTargets}
                                onClick={handleJoinClass}
                              >
                                Join Class
                              </button>
                            )}
                          </div>
                          {isBubbleMsg ? (
                            isEnableDropButton ||
                            videoPageInfo.ppClassVO ? null : (
                              <>
                                <Modal
                                  className="modal fade"
                                  show={isBubbleMsg}
                                  onHide={() => updateUserConfiguration()}
                                  size="lg"
                                  aria-labelledby="contained-modal-title-vcenter"
                                  dialogClassName="margin-dialog"
                                  contentClassName="border-0"
                                >
                                  <div className="chat clearfix">
                                    <div className="chat-history">
                                      <div className="message me-message text-right">
                                        <a
                                          className="closeicon position-absolute text-light"
                                          aria-hidden="true"
                                          onClick={() =>
                                            updateUserConfiguration()
                                          }
                                        >
                                          &times;
                                        </a>
                                        <p className="text-left">
                                          With the "Join Class" feature you can
                                          keep your professor up-to-date on your
                                          progress by joining the class.
                                          <br></br> <br></br>
                                          You can still use PracticePerfect, as
                                          usual, without joining your class.
                                        </p>
                                        <div className="d-flex">
                                          <button
                                            className="btn btn-light rounded-0 px-4 py-0 bubbleMsg-BtnText"
                                            onClick={() =>
                                              updateUserConfiguration()
                                            }
                                          >
                                            {" "}
                                            Got it
                                          </button>
                                          <a
                                            className="btn btn-light rounded-0 px-2 py-0 ml-3 bubbleMsg-BtnText"
                                            href="https://support.aspenpublishing.com/hc/en-us/articles/18000290435860"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {" "}
                                            Learn More
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Modal>
                              </>
                            )
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                  {userVO.userRole !== "Professor" ? (
                    <div className="input-group mx-3 mt-3">
                      <label htmlFor="searchVideoInput" className="sr-only">
                        Search videos
                      </label>
                      <input
                        id="searchVideoInput"
                        data-testid="input_search"
                        type="text"
                        disabled={isSearching}
                        value={searchVideo}
                        onChange={handleChangeSearchVideo}
                        onKeyPress={handleSearchVideo}
                        className="form-control ppvSearchInput"
                      />
                      <button
                        className="btn ppvSearchButton"
                        style={{ width: "90px" }}
                        disabled={isSearching}
                        value={searchVideo}
                        onClick={handleClickSearchVideo}
                        type="button"
                      >
                        Search
                      </button>
                    </div>
                  ) : null}
                </div>
                <div className="row mt-3">
                  {!showVideosFound && (
                    <>
                      {featuredVideo ? (
                        <div className="col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 pr-0">
                          <p className="ppvCommonStyle ppvFeaturedTitle mb-3">
                            Featured Video
                          </p>
                          <div>
                            <a
                              href="#"
                              data-testid="featured_video"
                              onClick={(e) => {
                                e.preventDefault();
                                goToWatchVideo(featuredVideo);
                              }}
                            >
                              <img
                                className="ppvImgBorder ppvCommonStyle w-100"
                                alt={featuredVideo.customerFacingSubTopicName}
                                src={
                                  featuredVideo.interactivePreviewPath ||
                                  featuredVideo.continuousPreviewPath
                                    ? localStorage.getItem("BASE_URL") +
                                      (featuredVideo.modeType == "interactive"
                                        ? featuredVideo.interactivePreviewPath
                                        : featuredVideo.continuousPreviewPath)
                                    : "/cc/images/PP_comingSoon.png"
                                }
                              />
                              <div className="ppvWatch ppvWatchWidth">
                                <span
                                  className="ppvWatchPercent"
                                  style={{
                                    width:
                                      featuredVideo.videoCompletionProgress +
                                      "%",
                                  }}
                                ></span>
                              </div>
                              <p className="ppvCommonStyle ppvRecentWatchText mt-3 mb-1">
                                {featuredVideo.customerFacingSubTopicName}
                              </p>
                            </a>
                            {videoButton(featuredVideo)}
                          </div>
                        </div>
                      ) : null}
                      <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
                        <p className="ppvCommonStyle ppvRecentWatchTitle">
                          Recently Watched
                        </p>
                        {videosRecentlyWatched &&
                        videosRecentlyWatched.length ? (
                          <>
                            {videosRecentlyWatched.map((recentVideo, i) => (
                              <div className="mt-4" key={i}>
                                <a
                                  data-testid="recently_watched_video"
                                  onClick={() => goToWatchVideo(recentVideo)}
                                >
                                  <img
                                    className="ppvImgBorder ppvCommonStyle w-100"
                                    alt={recentVideo.customerFacingSubTopicName}
                                    src={
                                      recentVideo.interactiveThumbnailPath ||
                                      recentVideo.continuousThumbnailPath
                                        ? localStorage.getItem("BASE_URL") +
                                          (recentVideo.modeType == "interactive"
                                            ? recentVideo.interactiveThumbnailPath
                                            : recentVideo.continuousThumbnailPath)
                                        : "/cc/images/PP_comingSoon.png"
                                    }
                                  />
                                  <div className="ppvWatch ppvWatchWidth">
                                    <span
                                      className="ppvWatchPercent"
                                      style={{
                                        width:
                                          recentVideo.videoCompletionProgress +
                                          "%",
                                      }}
                                    ></span>
                                  </div>
                                  <p className="ppvCommonStyle ppvRecentWatchText mb-2 mt-1">
                                    {recentVideo.customerFacingSubTopicName}
                                  </p>
                                </a>
                                {videoButton(recentVideo)}
                              </div>
                            ))}
                          </>
                        ) : (
                          <>
                            <span className="ppvCommonStyle">
                              You haven’t watched any videos yet.
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <div className="d-flex mb-3">
                      <div className="flex-grow-1 ppvCommonStyle ppvFeaturedTitle">
                        {showVideosFound ? "Search Results" : "All Videos"}
                      </div>
                      {!showMessage && (
                        <>
                          {/* <div className="text-right">
                            <p className="m-0">
                              <span className="ppvLayoutTxt"> Layout:</span>{" "}
                              &nbsp;
                              <a
                                data-testid="thumbnail_view"
                                onClick={() => selectViewDet("thumbnail_view")}
                                className={
                                  displayView == "thumbnail_view"
                                    ? "ppvActiveVideoView"
                                    : null
                                }
                              >
                                <i
                                  className="fa fa-th-large"
                                  style={{ fontSize: "23px", color: "#007ac3" }}
                                ></i>
                              </a>{" "}
                              &nbsp;
                              <a
                                data-testid="list_view"
                                onClick={() => selectViewDet("list_view")}
                                className={
                                  displayView == "list_view"
                                    ? "ppvActiveVideoView"
                                    : null
                                }
                              >
                                <i
                                  className="fa fa-bars"
                                  style={{ fontSize: "24px", color: "#007ac3" }}
                                ></i>
                              </a>
                            </p>
                          </div> */}
                          {/* Thumbnail List view button */}
                          <div className="text-right">
                            <p className="m-0">
                              <span className="ppvLayoutTxt">Layout:</span>
                              &nbsp;
                              <button
                                type="button"
                                style={{ border: "none", background: "none" }}
                                data-testid="thumbnail_view"
                                onClick={() => selectViewDet("thumbnail_view")}
                                className={
                                  displayView === "thumbnail_view"
                                    ? "ppvActiveVideoView"
                                    : ""
                                }
                                aria-label="Thumbnail view"
                                aria-pressed={displayView === "thumbnail_view"}
                              >
                                <i
                                  className="fa fa-th-large"
                                  style={{ fontSize: "23px", color: "#007ac3" }}
                                  aria-hidden="true"
                                ></i>
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                style={{ border: "none", background: "none" }}
                                data-testid="list_view"
                                onClick={() => selectViewDet("list_view")}
                                className={
                                  displayView === "list_view"
                                    ? "ppvActiveVideoView"
                                    : ""
                                }
                                aria-label="List view"
                                aria-pressed={displayView === "list_view"}
                              >
                                <i
                                  className="fa fa-bars"
                                  style={{ fontSize: "24px", color: "#007ac3" }}
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                    {showMessage && (
                      <>
                        <div>
                          <p className="ppvNoSearchResMsg">
                            There are no videos that match your search.
                          </p>
                          <a
                            className="ppvNoSearchResLink"
                            onClick={handleBackVideoLib}
                          >
                            {" "}
                            Back to Video Library{" "}
                          </a>
                        </div>
                        <hr />
                      </>
                    )}
                    {!showMessage && (
                      <>
                        {displayView == "thumbnail_view" ? (
                          <div className="">
                            {(!videosFound.length ? ppTopics : videosFound).map(
                              (ppTopicVO, i) => (
                                <div key={i}>
                                  <h4 className="ppvCommonStyle ppLogoText pl-0">
                                    {ppTopicVO.customerFacingTopicName}
                                  </h4>
                                  {ppTopicVO.ppSubTopicVOList &&
                                  ppTopicVO.ppSubTopicVOList.length ? (
                                    <div className="row border-bottom mb-2">
                                      {ppTopicVO.ppSubTopicVOList.map(
                                        (video, j) => (
                                          <div
                                            key={j}
                                            className="col-xl-3 col-lg-3 col-sm-6 col-12"
                                          >
                                            <a
                                              onClick={() =>
                                                goToWatchVideo(video)
                                              }
                                            >
                                              <img
                                                className="ppvImgBorder ppvCommonStyle w-100"
                                                alt={
                                                  video.customerFacingSubTopicName
                                                }
                                                src={
                                                  video.interactiveThumbnailPath ||
                                                  video.continuousThumbnailPath
                                                    ? localStorage.getItem(
                                                        "BASE_URL",
                                                      ) +
                                                      (video.modeType ==
                                                      "interactive"
                                                        ? video.interactiveThumbnailPath
                                                        : video.continuousThumbnailPath)
                                                    : "/cc/images/PP_comingSoon.png"
                                                }
                                              />
                                              <div className="ppvWatch ppvWatchWidth">
                                                <span
                                                  className="ppvWatchPercent"
                                                  style={{
                                                    width:
                                                      video.videoCompletionProgress +
                                                      "%",
                                                  }}
                                                ></span>
                                              </div>
                                              <p className="ppvCommonStyle ppvRecentWatchText mt-1 mb-2">
                                                {
                                                  video.customerFacingSubTopicName
                                                }
                                              </p>
                                            </a>
                                            {videoButton(video)}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  ) : null}
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <ul className="ppvColDiv p-0">
                            {(!videosFound.length ? ppTopics : videosFound).map(
                              (ppTopicVO, i) => (
                                <li key={i}>
                                  <div className="d-inline-block p-0 ppvAutoFill">
                                    <h4 className="mb-3 ppvCommonStyle ppvTitleTxt">
                                      {ppTopicVO.customerFacingTopicName}
                                    </h4>
                                    <div className="ml-4">
                                      {ppTopicVO.ppSubTopicVOList.map(
                                        (video, j) => (
                                          <div key={j}>
                                            <div className="ppvCommonStyle ppvRecentWatchText mb-1 ">
                                              <div className="row pl-xl-4 pl-lg-4 pl-md-4 pl-sm-2 pl-2">
                                                <div className="col-xl-2 col-lg-3 col-md-2 col-sm-3 col-xs-3 col-3">
                                                  <a
                                                    data-testid="watch_video_icon"
                                                    onClick={() =>
                                                      goToWatchVideo(video)
                                                    }
                                                  >
                                                    <i className="fa fa-play ppvPlayButton"></i>
                                                    <svg
                                                      className="ppvProgrCircle"
                                                      width="45px"
                                                      height="45px"
                                                    >
                                                      <circle
                                                        className="ppvUnWatchProgrCircle"
                                                        cx="25"
                                                        cy="25"
                                                        r="15"
                                                      ></circle>
                                                      <circle
                                                        className="ppvWatchProgrCircle"
                                                        cx="25"
                                                        cy="25"
                                                        r="15"
                                                        style={{
                                                          strokeDasharray:
                                                            video.videoCompletionProgress !=
                                                            undefined
                                                              ? video.videoCompletionProgress <
                                                                90
                                                                ? video.videoCompletionProgress +
                                                                  ",999"
                                                                : video.videoCompletionProgress ==
                                                                    100
                                                                  ? "94,999"
                                                                  : "92,999"
                                                              : null,
                                                        }}
                                                      ></circle>
                                                    </svg>
                                                  </a>
                                                </div>
                                                <div
                                                  className="col-xl-10 col-lg-9 col-md-10 col-sm-9 col-xs-9 col-9 p-0"
                                                  style={{ marginLeft: "-3%" }}
                                                >
                                                  <a
                                                    data-testid="watch_video"
                                                    onClick={() =>
                                                      goToWatchVideo(video)
                                                    }
                                                  >
                                                    {
                                                      video.customerFacingSubTopicName
                                                    }
                                                  </a>
                                                  {videoButton(video)}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                </li>
                              ),
                            )}
                          </ul>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <Modal
                  className="modal fade"
                  show={isDropClass}
                  onHide={() => setDropClass(false)}
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  contentClassName="popupContentBorder"
                >
                  <Modal.Header
                    className="close text-right ppStdPopUpClose"
                    closeButton
                  />
                  <div className="ppStdClassDropPopUp">
                    {(classInfo || videoPageInfo.ppClassVO) && (
                      <p className="dropClassPopUp-title">{`You are about to drop Professor ${classInfo.profLastName || videoPageInfo.ppClassVO.profLastName}'s "${classInfo.ppClassName || videoPageInfo.ppClassVO.ppClassName} ${classInfo.ppSemester || videoPageInfo.ppClassVO.ppSemester} ${classInfo.ppYear || videoPageInfo.ppClassVO.ppYear}" class. Your graded video quiz scores will not be visible to Professor ${classInfo.profLastName || videoPageInfo.ppClassVO.profLastName} anymore.`}</p>
                    )}
                    <p className="dropClassPopUp-text">
                      Do you want to drop this class?
                    </p>
                    <div className="text-center">
                      <button
                        className="btn btn-primary px-4 py-1 dropPopup-noBtn"
                        onClick={() => setDropClass(false)}
                      >
                        No
                      </button>
                      <button
                        className="btn btn-light px-4 py-1 dropPopup-yesBtn ml-3"
                        onClick={() => dropClass()}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  className="modal fade"
                  show={isCodeRedeem}
                  onHide={() => setCodeRedeem(false)}
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  contentClassName="popupContentBorder"
                >
                  <Modal.Header
                    className="close text-right ppStdPopUpClose"
                    closeButton
                  />
                  <div className="ppStdClassDropPopUp">
                    {classInfo && (
                      <p className="dropClassPopUp-title">{`You are now enrolled in Professor ${classInfo.profLastName}'s "${classInfo.ppClassName} ${classInfo.ppSemester} ${classInfo.ppYear}" class. Your graded video quiz scores will be visible to Professor ${classInfo.profLastName}.`}</p>
                    )}
                    {/* <p className="dropClassPopUp-text">Do you want to join this class?</p> */}
                    <div className="text-center">
                      <button
                        className="btn btn-primary px-4 py-1 dropPopup-noBtn"
                        onClick={() => setCodeRedeem(false)}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  className="modal fade"
                  show={isJoinClass}
                  onHide={() => setIsJoinClass(false)}
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  contentClassName="popupContentBorder"
                >
                  <Modal.Header
                    className="close text-right ppStdPopUpClose"
                    closeButton
                  />
                  <div className="ppStdClassDropPopUp">
                    <p className="dropClassPopUp-title">
                      Enter the PracticePerfect class code shared by your
                      Professor/Instructor.
                    </p>
                    <div className="w-75 m-auto">
                      <input
                        data-testid="input_class_code"
                        type="text"
                        className="form-control rounded-0 classTabFontFamily"
                        value={classCode}
                        onKeyPress={(e) => {
                          handleJoinKeyPress(e);
                        }}
                        onChange={(e) => setClassCode(e.target.value)}
                      />
                      {errClassCode && (
                        <span className="delePopup-colRed">
                          Error: Class Code is Required.
                        </span>
                      )}
                      {isInvalidClassCode && (
                        <span className="delePopup-colRed">
                          Error: The class code you entered does not exist.
                          Please check the code and try again.
                        </span>
                      )}
                      {isAlreadyRedeemCode && (
                        <span className="delePopup-colRed">
                          Error: Already redeem another PP class code.
                        </span>
                      )}
                    </div>
                    <p className="dropClassPopUp-text mt-2">
                      Please note that a PracticePerfect class code is different
                      from a PracticePerfect access code.
                    </p>
                    <div className="text-center">
                      <button
                        className="btn btn-primary px-4 py-1 dropPopup-noBtn"
                        onClick={() => joinClass()}
                      >
                        Join
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  className="modal fade PPProfWelcomePopup"
                  contentClassName="p-4"
                  show={isShowStdQuizResetPopup}
                  onHide={() => setShowStdQuizResetPopup(false)}
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                >
                  <div className="ppProfQuizResetPopUp">
                    <Modal.Header>
                      <Modal.Title className="ProfWelcomePopupTitle">
                        Your quizzes have been updated
                      </Modal.Title>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        ref={ppQuizResetPopupFocus}
                        onClick={() => setShowStdQuizResetPopup(false)}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                      <p className="PPWelProfPopupTxt mb-2 pt-3">
                        We regret to inform you that there was an editorial
                        error in the following quizzes, which requires us to
                        update the quizzes. The below-mentioned questions have
                        been removed to maintain the highest quality content on
                        our platform. Therefore, if you have already attempted
                        any of the quizzes or are currently in the process of
                        attempting them, we have updated your scores and
                        progress on these quizzes. We apologize for the
                        inconvenience this has caused and appreciate your
                        understanding.
                      </p>
                      <br></br>
                      <p>List of the questions that were deleted:</p>
                      <ol className="pl-3">
                        {Boolean(isResetNotificationData)
                          ? isResetNotificationData.map((resetChapterData) => {
                              return (
                                <li>
                                  <p>{resetChapterData.Message}</p>
                                </li>
                              );
                            })
                          : null}
                      </ol>
                      <div className="PPProfWelChecboxDivBottom mt-5">
                        <label style={{ marginTop: "5px" }}>
                          <input
                            type="checkbox"
                            onChange={() => updatePPRestNotification(3)}
                            value=""
                          />{" "}
                          Do not show this message again
                        </label>
                        <button
                          style={{ float: "right" }}
                          className="btn btn-primary rounded-0 ppProfQuizUpdatedPopup px-3 py-1 ml-2"
                          onClick={() => setShowStdQuizResetPopup(false)}
                        >
                          OK
                        </button>
                      </div>
                    </Modal.Body>
                  </div>
                </Modal>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
export default withAuth(PracticePerfectVideos);
